import { Button } from "@mui/joy";
import useOpenTask from "hooks/useOpenTask";

export default function OpenChatButton() {
  const openChat = useOpenTask({ taskKey: "chat" });

  // 채팅을 여는 것만으로는 읽음 처리하지 않는다 — 읽음 처리는 명시적 액션
  // (답장 발송 / "답장 불필요" 버튼)으로만 수행한다. (CoachingContent 참조)
  return (
    <Button variant={"Solid"} onClick={() => openChat()}>
      채팅 확인하기
    </Button>
  );
}
